export const ONBOARDING_JOB_TITLE_OPTIONS = [
  {
    id: 1,
    title: 'onboarding_questionnaire_select_option_enterprise_owner',
    value: 'Enterprise Owner',
    role: 1,
  },
  {
    id: 2,
    title: 'onboarding_questionnaire_select_option_agency_owner',
    value: 'Marketing Agency Owner',
    role: 1,
  },
  {
    id: 3,
    title: 'onboarding_questionnaire_select_option_small_business_owner',
    value: 'Small Business Owner',
    role: 1,
  },
  {
    id: 4,
    title: 'onboarding_questionnaire_select_option_seo_specialist',
    value: 'SEO Specialist',
    role: 2,
  },
  {
    id: 5,
    title: 'onboarding_questionnaire_select_option_content_specialist',
    value: 'Content Specialist',
    role: 2,
  },
  {
    id: 6,
    title: 'onboarding_questionnaire_select_option_content_creator',
    value: 'Content Creator',
    role: 2,
  },
  {
    id: 7,
    title: 'onboarding_questionnaire_select_option_media_manager',
    value: 'Social Media Manager',
    role: 2,
  },
  {
    id: 8,
    title: 'onboarding_questionnaire_select_option_copy_writer',
    value: 'Copy Writer',
    role: 2,
  },
  {
    id: 9,
    title: 'onboarding_questionnaire_select_option_seo_specialist',
    value: 'SEO Specialist',
    role: 3,
  },
  {
    id: 10,
    title: 'onboarding_questionnaire_select_option_content_specialist',
    value: 'Content Specialist',
    role: 3,
  },
  {
    id: 11,
    title: 'onboarding_questionnaire_select_option_content_creator',
    value: 'Content Creator',
    role: 3,
  },
  {
    id: 12,
    title: 'onboarding_questionnaire_select_option_media_manager',
    value: 'Social Media Manager',
    role: 3,
  },
  {
    id: 13,
    title: 'onboarding_questionnaire_select_option_copy_writer',
    value: 'Copy Writer',
    role: 3,
  },
  {
    id: 14,
    title: 'onboarding_questionnaire_select_option_seo_specialist',
    value: 'SEO Specialist',
    role: 4,
  },
  {
    id: 15,
    title: 'onboarding_questionnaire_select_option_content_specialist',
    value: 'Content Specialist',
    role: 4,
  },
  {
    id: 16,
    title: 'onboarding_questionnaire_select_option_content_creator',
    value: 'Content Creator',
    role: 4,
  },
  {
    id: 17,
    title: 'onboarding_questionnaire_select_option_media_manager',
    value: 'Social Media Manager',
    role: 4,
  },
  {
    id: 18,
    title: 'onboarding_questionnaire_select_option_copy_writer',
    value: 'Copy Writer',
    role: 4,
  },
  {
    id: 19,
    title: 'onboarding_questionnaire_select_option_seo_specialist',
    value: 'SEO Specialist',
    role: 5,
  },
  {
    id: 20,
    title: 'onboarding_questionnaire_select_option_content_specialist',
    value: 'Content Specialist',
    role: 5,
  },
  {
    id: 21,
    title: 'onboarding_questionnaire_select_option_content_creator',
    value: 'Content Creator',
    role: 5,
  },
  {
    id: 22,
    title: 'onboarding_questionnaire_select_option_media_manager',
    value: 'Social Media Manager',
    role: 5,
  },
  {
    id: 23,
    title: 'onboarding_questionnaire_select_option_copy_writer',
    value: 'Copy Writer',
    role: 5,
  },
]
